import React from "react";
import { Button, Icon, Image } from "semantic-ui-react";

const fileIcons = {
  "application/pdf": "file pdf outline",
  "image/jpeg": "file image",
  "image/gif": "file image",
  "image/png": "file image",
  "application/x-kmd-url": "linkify",
};

const Attachment = ({ file, showClose, onClose }) => {
  const iconName = fileIcons[file.contentType] || "file";
  return (
    <div className="Attachment">
      {file.contentType.startsWith("image/") ? (
        <Image
          href={file.url}
          target="_blank"
          rel="noopener noreferrer"
          verticalAlign="middle"
          src={file.url}
          size="small"
          style={{ marginRight: "0.25rem" }}
        />
      ) : (
        <>
          <Icon name={iconName} size="large" />
          <a href={file.url} target="_blank" rel="noopener noreferrer">
            {file.name || file.url}
          </a>
        </>
      )}

      {showClose ? (
        <Button className="close" icon size="mini" onClick={onClose}>
          <Icon name="close" />
        </Button>
      ) : null}
    </div>
  );
};
export default Attachment;
